import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface HavGuest {
  id?: string;
  first_name: string;
  last_name: string;
  email?: string | null;
  phone?: string | null;
  seat_category?: string | null;
  ticket_code?: string | null;
}

export interface HavRegistration {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string | null;
  sponsor_name: string;
  seat_category: string;
  ticket_code: string;
  seats_count: number;
  amount: number;
  additional_donation: number | null;
  payment_status: string;
  approval_status: string;
  refusal_reason: string | null;
  cerfa_url: string | null;
  created_at: string;
  registration_type?: string | null;
  guests: HavGuest[] | null;
}

export const useHavData = () => {
  const [registrations, setRegistrations] = useState<HavRegistration[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchRegistrations = useCallback(async () => {
    try {
      setIsLoading(true);
      const { data, error: fetchError } = await supabase.rpc("get_hav_registrations");
      if (fetchError) throw fetchError;
      setRegistrations(((data as unknown) as HavRegistration[]) || []);
      setError(null);
    } catch (err) {
      console.error("Error fetching HAV registrations:", err);
      setError(err instanceof Error ? err : new Error("Unknown error"));
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRegistrations();
  }, [fetchRegistrations]);

  return { registrations, isLoading, error, refetch: fetchRegistrations };
};
